import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import style from './style.module.less';

const UnexpectedValueComponent = () => {
  return (
    <div className={style['unexpected-value']}>
      <FormattedMessage {...messages.unexpectedValueMessage} />
    </div>
  );
};

export default UnexpectedValueComponent;
